import { Injectable } from '@angular/core'
import { MatPaginatorIntl } from '@angular/material/paginator'

@Injectable()
export class MatPaginatorIntlGerman extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Bestellungen pro Seite'
  override nextPageLabel = 'Nächste Seite'
  override previousPageLabel = 'Vorherige Seite'
  override firstPageLabel = 'Erste Seite'
  override lastPageLabel = 'Letzte Seite'

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    const startIndex = page * pageSize
    const endIndex = Math.min(startIndex + pageSize, length)
    return `${startIndex + 1}–${endIndex} von ${length}`
  }
}
